/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiRun,
  AiRunRequestInput,
  AiRunUpdateRequestInput,
  PaginatedAiRuns,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Run
 */
export const createAiRun = (
    aiRunRequestInput: MaybeRefOrGetter<AiRunRequestInput>,
 signal?: AbortSignal
) => {
      aiRunRequestInput = toValue(aiRunRequestInput);

      return axiosClient<AiRun>(
      {url: `/ai/runs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiRunRequestInput, signal
    },
      );
    }




export const getCreateAiRunMutationKey = () => ['createAiRun'] as const;

export const getCreateAiRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiRun>>, TError,CreateAiRunMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiRun>>, TError,CreateAiRunMutationVariables, TContext> => {

const mutationKey = getCreateAiRunMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiRun>>, CreateAiRunMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAiRun(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof createAiRun>>>
    export type CreateAiRunMutationBody = AiRunRequestInput
    export type CreateAiRunMutationError = ErrorType<void>
    export type CreateAiRunMutationVariables = {data: AiRunRequestInput}

    /**
 * @summary Create AI Run
 */
export const useCreateAiRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiRun>>, TError,CreateAiRunMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiRun>>,
        TError,
        CreateAiRunMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAiRunMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI Runs
 */
export const listAiRuns = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedAiRuns>(
      {url: `/ai/runs`, method: 'GET', signal
    },
      );
    }




export const getListAiRunsQueryKey = () => {
    return [
    'ai','runs'
    ] as const;
    }


export const getListAiRunsQueryOptions = <TData = Awaited<ReturnType<typeof listAiRuns>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiRuns>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiRunsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiRuns>>> = ({ signal }) => listAiRuns(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiRuns>>, TError, TData>
}

export type ListAiRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiRuns>>>
export type ListAiRunsQueryError = ErrorType<void>


/**
 * @summary List of AI Runs
 */

export function useListAiRuns<TData = Awaited<ReturnType<typeof listAiRuns>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiRuns>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiRunsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI Run Details
 */
export const deleteAiRun = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/runs/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiRunMutationKey = () => ['deleteAiRun'] as const;

export const getDeleteAiRunMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiRun>>, TError,DeleteAiRunMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiRun>>, TError,DeleteAiRunMutationVariables, TContext> => {

const mutationKey = getDeleteAiRunMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiRun>>, DeleteAiRunMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiRun(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiRun>>>

    export type DeleteAiRunMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiRunMutationVariables = {id: string}

    /**
 * @summary Delete AI Run Details
 */
export const useDeleteAiRun = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiRun>>, TError,DeleteAiRunMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiRun>>,
        TError,
        DeleteAiRunMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiRunMutationOptions(options), queryClient);
    }
    /**
 * @summary AI Run Details
 */
export const getAiRun = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiRun>(
      {url: `/ai/runs/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiRunQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','runs',id
    ] as const;
    }


export const getGetAiRunQueryOptions = <TData = Awaited<ReturnType<typeof getAiRun>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiRun>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiRunQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiRun>>> = ({ signal }) => getAiRun(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiRun>>, TError, TData>
}

export type GetAiRunQueryResult = NonNullable<Awaited<ReturnType<typeof getAiRun>>>
export type GetAiRunQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary AI Run Details
 */

export function useGetAiRun<TData = Awaited<ReturnType<typeof getAiRun>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiRun>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiRunQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update AI Run
 */
export const updateAiRun = (
    id: MaybeRefOrGetter<string>,
    aiRunUpdateRequestInput: MaybeRefOrGetter<AiRunUpdateRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
aiRunUpdateRequestInput = toValue(aiRunUpdateRequestInput);

      return axiosClient<AiRun>(
      {url: `/ai/runs/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aiRunUpdateRequestInput, signal
    },
      );
    }




export const getUpdateAiRunMutationKey = () => ['updateAiRun'] as const;

export const getUpdateAiRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiRun>>, TError,UpdateAiRunMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiRun>>, TError,UpdateAiRunMutationVariables, TContext> => {

const mutationKey = getUpdateAiRunMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiRun>>, UpdateAiRunMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiRun(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiRun>>>
    export type UpdateAiRunMutationBody = AiRunUpdateRequestInput
    export type UpdateAiRunMutationError = ErrorType<void>
    export type UpdateAiRunMutationVariables = {id: string;data: AiRunUpdateRequestInput}

    /**
 * @summary Update AI Run
 */
export const useUpdateAiRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiRun>>, TError,UpdateAiRunMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiRun>>,
        TError,
        UpdateAiRunMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAiRunMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel AI Run
 */
export const cancelAiRun = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/runs/${id}/cancel`, method: 'PUT', signal
    },
      );
    }




export const getCancelAiRunMutationKey = () => ['cancelAiRun'] as const;

export const getCancelAiRunMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiRun>>, TError,CancelAiRunMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelAiRun>>, TError,CancelAiRunMutationVariables, TContext> => {

const mutationKey = getCancelAiRunMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAiRun>>, CancelAiRunMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  cancelAiRun(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAiRun>>>

    export type CancelAiRunMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CancelAiRunMutationVariables = {id: string}

    /**
 * @summary Cancel AI Run
 */
export const useCancelAiRun = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiRun>>, TError,CancelAiRunMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelAiRun>>,
        TError,
        CancelAiRunMutationVariables,
        TContext
      > => {
      return useMutation(getCancelAiRunMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel AI Run
 */
export const retryAiRun = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/runs/${id}/retry`, method: 'PUT', signal
    },
      );
    }




export const getRetryAiRunMutationKey = () => ['retryAiRun'] as const;

export const getRetryAiRunMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAiRun>>, TError,RetryAiRunMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof retryAiRun>>, TError,RetryAiRunMutationVariables, TContext> => {

const mutationKey = getRetryAiRunMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryAiRun>>, RetryAiRunMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  retryAiRun(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof retryAiRun>>>

    export type RetryAiRunMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RetryAiRunMutationVariables = {id: string}

    /**
 * @summary Cancel AI Run
 */
export const useRetryAiRun = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAiRun>>, TError,RetryAiRunMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof retryAiRun>>,
        TError,
        RetryAiRunMutationVariables,
        TContext
      > => {
      return useMutation(getRetryAiRunMutationOptions(options), queryClient);
    }
    /**
 * @summary Approve AI Tool Approval
 */
export const approveAiToolApproval = (
    runId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      runId = toValue(runId);
id = toValue(id);

      return axiosClient<AiRun>(
      {url: `/ai/runs/${runId}/tool_approvals/${id}/approve`, method: 'POST', signal
    },
      );
    }




export const getApproveAiToolApprovalMutationKey = () => ['approveAiToolApproval'] as const;

export const getApproveAiToolApprovalMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAiToolApproval>>, TError,ApproveAiToolApprovalMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveAiToolApproval>>, TError,ApproveAiToolApprovalMutationVariables, TContext> => {

const mutationKey = getApproveAiToolApprovalMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAiToolApproval>>, ApproveAiToolApprovalMutationVariables> = (props) => {
          const {runId,id} = props ?? {};

          return  approveAiToolApproval(runId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAiToolApprovalMutationResult = NonNullable<Awaited<ReturnType<typeof approveAiToolApproval>>>

    export type ApproveAiToolApprovalMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type ApproveAiToolApprovalMutationVariables = {runId: string;id: string}

    /**
 * @summary Approve AI Tool Approval
 */
export const useApproveAiToolApproval = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAiToolApproval>>, TError,ApproveAiToolApprovalMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof approveAiToolApproval>>,
        TError,
        ApproveAiToolApprovalMutationVariables,
        TContext
      > => {
      return useMutation(getApproveAiToolApprovalMutationOptions(options), queryClient);
    }
    /**
 * @summary Reject AI Tool Approval
 */
export const rejectAiToolApproval = (
    runId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      runId = toValue(runId);
id = toValue(id);

      return axiosClient<AiRun>(
      {url: `/ai/runs/${runId}/tool_approvals/${id}/reject`, method: 'POST', signal
    },
      );
    }




export const getRejectAiToolApprovalMutationKey = () => ['rejectAiToolApproval'] as const;

export const getRejectAiToolApprovalMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAiToolApproval>>, TError,RejectAiToolApprovalMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectAiToolApproval>>, TError,RejectAiToolApprovalMutationVariables, TContext> => {

const mutationKey = getRejectAiToolApprovalMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAiToolApproval>>, RejectAiToolApprovalMutationVariables> = (props) => {
          const {runId,id} = props ?? {};

          return  rejectAiToolApproval(runId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectAiToolApprovalMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAiToolApproval>>>

    export type RejectAiToolApprovalMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RejectAiToolApprovalMutationVariables = {runId: string;id: string}

    /**
 * @summary Reject AI Tool Approval
 */
export const useRejectAiToolApproval = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAiToolApproval>>, TError,RejectAiToolApprovalMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof rejectAiToolApproval>>,
        TError,
        RejectAiToolApprovalMutationVariables,
        TContext
      > => {
      return useMutation(getRejectAiToolApprovalMutationOptions(options), queryClient);
    }
